// extracted by mini-css-extract-plugin
module.exports = {"root":"StatsBlock_root__Aw_MR"};